import React, { useState } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
interface MobileLayoutProps {
  children: React.ReactNode;
  noPadding?: boolean;
}
export function MobileLayout({
  children,
  noPadding = false
}: MobileLayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  return <div className="min-h-screen bg-background" data-id="element-335">
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} data-id="element-336" />

      <div className="lg:ml-64" data-id="element-337">
        <Header onMenuClick={() => setIsSidebarOpen(true)} data-id="element-338" />

        <main className={noPadding ? '' : 'p-4 lg:p-8 pb-safe'} data-id="element-339">
          {children}
        </main>
      </div>
    </div>;
}